import { z } from 'zod';

import { BankAccountNumber, BankRoutingNumber } from './BankAccount';
import { BorrowerId } from './BrandedIds';

export const RepayPayAccountInput = z.object({
  accountNumber: BankAccountNumber,
  routingNumber: BankRoutingNumber,
  accountType: z.enum(['checking', 'savings']),
  // NOTE: this field is not in Repay's API docs, but they emailed me specifically to start including it.
  // True means a business/corporate account; RepayClient converts to the wire format each endpoint expects.
  accountBusiness: z.boolean(),
  firstName: z.string(),
  lastName: z.string(),
  email: z.email(),
});

export type RepayPayAccountInput = z.infer<typeof RepayPayAccountInput>;

export const CreateRepayAccountInput = RepayPayAccountInput.extend({
  borrowerId: BorrowerId,
});

export type CreateRepayAccountInput = z.infer<typeof CreateRepayAccountInput>;
